module.exports = __webpack_public_path__ + "img/img_gate04.efd75e88.jpg";